import { runCustomCommand } from '@/services/maps';

const initialState = {
  executedCommand: null,
  runningCommand: null,
};

const Model = {
  namespace: 'maps',
  state: initialState,
  effects: {
    *runInfoWindowCommand({ payload }, { call, put }) {
      try {
        yield put({ type: 'queryRunningCommand', payload: payload.command });
        yield call(runCustomCommand, payload);
        yield put({ type: 'queryInfoWindowCommand', payload });
      } catch (e) {}
    },

    *cleanup(_, { put }) {
      yield put({ type: 'reset' });
    },
  },
  reducers: {
    queryRunningCommand(state, { payload }) {
      return {
        ...state,
        runningCommand: payload,
      };
    },

    queryInfoWindowCommand(state, { payload }) {
      return {
        ...state,
        executedCommand: payload.command,
      };
    },

    reset(state) {
      return {
        ...initialState,
      };
    },
  },
};

export default Model;
